import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SmartBtnModule } from '@y42/core/smart-btn';
import { DataTestCommitButtonComponent } from './data-test-commit-button.component';

@NgModule({
  declarations: [DataTestCommitButtonComponent],
  imports: [CommonModule, SmartBtnModule, FontAwesomeModule, MatTooltipModule],
  exports: [DataTestCommitButtonComponent],
})
export class DataTestCommitButtonModule {}
